<template>
    <div class="bg-img sh-100">
        <v-container>
            <v-card class="mx-auto mt-12" max-width="80%">
                <v-container class="pa-0">
                    <v-row class="w-100 ma-0">
                        <v-col cols="6" class="blue-bg text-center">
                            <v-img :src="require('./../assets/VULlogo.png')" contain height="100"></v-img>
                            <v-card-title class="white--text text-uppercase font-weight-regular text-center break-word d-block">Virginia University of Lynchburg</v-card-title>
                            <v-card-text class="white--text mt-8">
                                Welcome to DHA
                                <p class="font-weight-thin">
                                    LoginIn and stay connected with all the activities
                                </p> 
                            </v-card-text>
                        </v-col>
                        <v-col cols="6">
                            <v-card-title class="primary--text">Already have an account?</v-card-title>
                            <v-form ref="form" class="pa-4">
                                <label class="label pl-0 grey-label">Email Address</label>
                                <v-text-field filled dense class="mt-2" v-model="email" :rules="emailRules"></v-text-field>
                                <label class="label pl-0 grey-label">Password</label>
                                <v-text-field filled dense class="mt-2" v-model="password" :type="showPassword?'text':'password'" 
                                :append-icon="showPassword?'mdi-eye':'mdi-eye-off'" @click:append="showPassword = !showPassword" :rules="passwordRules">
                                </v-text-field>
                                <a href="" class="decoration-none float-right">
                                    <small>Forgot Password?</small>
                                </a>
                                <v-btn color="#0b295f" dark block class="mt-8" :loading="loading" @click="login">Log In</v-btn>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                email: '',
                password: '',
                showPassword: false,
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
                ],
                passwordRules: [
                    v => !!v || 'Password is required',
                    v => (v && v.length >= 6) || 'Password must be atleast 6 characters long'
                ],
                loading: false
            }
        },
        methods: {
            login(){

            }
        }
    }
</script>

<style scoped>
    .blue-bg{
        background-color: #0b295f;
    }
    .w-100{
        width: 100% !important;
    }
    .break-word{
        word-break: break-word !important;
    }
    .grey-label{
        color: grey !important;
    }
    .label{
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: 1.6px;
        font-weight: 400;
    }
    .sh-100{
        height: 100vh;
    }
    .bg-img{
        background: linear-gradient( rgba(0,0,0,0.7), rgba(0, 0, 0, 0.7) ),url(./../assets/backgroundimg.jpg) no-repeat center center fixed;
    }
</style>